import etribeMarkUrl from '@/assets/logos/etribe-mark.svg';

/* =====================================================================
   BrandHeader — bloque de identidad eTribe reutilizable.

   Usa `<img>` (en vez de import `?react`) porque etribe-mark.svg lleva
   un `<style>` interno con fills hardcoded — `<img>` lo renderiza
   directamente sin que vite-plugin-svgr lo procese.
===================================================================== */

export function BrandHeader() {
  return (
    <div className="brand">
      <img src={etribeMarkUrl} className="brand-logo" alt="eTribe" />
    </div>
  );
}
